
import './style.scss';
import { Box, Tooltip, Typography } from '@mui/material';
import { ServicePriorityData, ServicePropertyData, ServiceStatusData } from '../../../data/Enums';
import { useMemo } from 'react';
import { useLanguageContext } from '../../../contexts/LanguageContext';
import IServiceOrder from '../../../interfaces/IServiceOrder';


interface ICardProps {
    title: string;
    prefix?: string | undefined;
    serviceOrder: IServiceOrder;
    showStatusTooltip?: boolean;
    onClick?: () => void;
    className?: string;
}


const Card: React.FC<ICardProps> = ({
    title, 
    prefix = undefined,
    serviceOrder,
    showStatusTooltip = false,
    onClick = () => {},
    className = ''
}) => {
    const { translate } = useLanguageContext();


    const status = useMemo(() => {
        return Object.values(ServiceStatusData).find(s => serviceOrder.statusId !== undefined && +s.key === +serviceOrder.statusId);
    }, [serviceOrder]);

    
    const priority = useMemo(() => {
        return Object.values(ServicePriorityData).find(s => serviceOrder.priorityId !== undefined && +s.key === +serviceOrder.priorityId);
    }, [serviceOrder]);


    const statusIcon = useMemo(() => {
        if (status) {
            const statusIcon = <status.Icon className='icon-status' sx={{ backgroundColor: `${status.color} !important` }} />;

            if (showStatusTooltip) {
                return <Tooltip title={translate(status.name)} placement="left" arrow disableInteractive>
                    {statusIcon}
                </Tooltip>;
            } else {
                return statusIcon;
            }
        }

        return null;
    }, [status, showStatusTooltip, translate]);

    
    return (
        <Box 
            onClick={onClick}
            className={`service-card ${className}`}
            sx={{
                backgroundColor: `${priority?.color} !important`
            }}
        >
            <Box className='box-data'>
                <Typography variant='subtitle1' className='text-title'>
                    <Typography variant='subtitle1' className='text-title-prefix'> {prefix} </Typography>
                    {title} 
                </Typography>

                <Box className='box-status'>
                    {statusIcon}
                </Box>
            </Box>
                
            <Box className='box-information'>
                {
                    Object.values(ServicePropertyData).map(s => {
                        const key = (s.partnerId ?? '') as keyof(IServiceOrder);

                        if (serviceOrder[key] !== undefined) {
                            return <Box className={`box-information-item ${s.className}`} sx={{ backgroundColor: `${s.color} !important` }}>
                                {
                                    s.type === 'array' && (
                                        <Typography className='box-information-text'> {(serviceOrder[key] as any[]).length} </Typography>
                                    )
                                }

                                <s.Icon className='box-information-icon' />
                            </Box>;
                        }

                        return null;
                    })
                }
            </Box>
        </Box>
    );
}

export default Card;